export default __webpack_public_path__ + "resources/icons/d232-8bf2.webp";